import { render } from "./TicketView.vue?vue&type=template&id=ad079676&scoped=true"
import script from "./TicketView.vue?vue&type=script&lang=js"
export * from "./TicketView.vue?vue&type=script&lang=js"

import "./TicketView.vue?vue&type=style&index=0&id=ad079676&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad079676"]])

export default __exports__